import React from "react";
import { connectStateResults } from "react-instantsearch-dom";

type StateResultsProps = {
  searchResults?: { nbHits: number };
  children?: React.ReactNode;
  fallback?: React.ReactNode;
  noResults?: React.ReactNode;
};

const StateResults: React.FunctionComponent<any> = (props): JSX.Element | null => {
  const { searchResults, fallback, noResults, children }: StateResultsProps = props;
  const hasResults = searchResults && searchResults.nbHits !== 0;
  // const nbHits = searchResults && searchResults.nbHits;

  // No result returned yet
  if (fallback && !searchResults) {
    return <>{fallback}</>;
  }
  // Result returned bu not hits
  else if (noResults && !hasResults) {
    return <>{noResults}</>;
  }
  if (children) {
    return <>{children}</>;
  }
  return null;
};

export default connectStateResults(StateResults);
